import { useState } from "react";
import { NavLink } from "react-router-dom";
import "../css/Header.css";

const Header = () => {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  return (
    <>
      <header className="header">
        <div className="header-inner">

          <div className="hamburger" onClick={() => setOpen(true)}>
            <span />
            <span />
            <span />
          </div>

          <div className="logo">
            NEO CAFÉ
            <small>ARTISAN COFFEE HOUSE</small>
          </div>

          <nav className="nav desktop-nav">
            <NavLink to="/" end>Home</NavLink>
            <NavLink to="/about">About</NavLink>
            <NavLink to="/menu">Menu</NavLink>
            <NavLink to="/gallery">Gallery</NavLink>
            <NavLink to="/reviews">Reviews</NavLink>
            <NavLink to="/faqs">FAQs</NavLink>
            <NavLink to="/contact">Contact</NavLink>
          </nav>

        </div>
      </header>

      {/* MOBILE SIDEBAR */}
      <div className={`sidebar ${open ? "open" : ""}`}>
        <div className="close" onClick={closeMenu}>✕</div>

        <nav className="mobile-nav">
          <NavLink to="/" end onClick={closeMenu}>Home</NavLink>
          <NavLink to="/about" onClick={closeMenu}>About</NavLink>
          <NavLink to="/menu" onClick={closeMenu}>Menu</NavLink>
          <NavLink to="/gallery" onClick={closeMenu}>Gallery</NavLink>
          <NavLink to="/reviews" onClick={closeMenu}>Reviews</NavLink>
          <NavLink to="/faqs" onClick={closeMenu}>FAQs</NavLink>
          <NavLink to="/contact" onClick={closeMenu}>Contact</NavLink>
        </nav>
      </div>
    </>
  );
};

export default Header;
